import React from "react";
import { Alert, Button, Col, Row } from "react-bootstrap";
import { Search } from "react-bootstrap-icons";
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import { MyContext } from "../Context/MyContext";

export const HeaderContratos = ( {titulo, pesquisa, setPesquisa,  
                              pesquisarClick} ) => {

    const { handleTipoPesquisaContratosChange, tipoPesquisaContratos } = React.useContext(MyContext);

    function atualizarTipoPesquisa( {target} ) {
        handleTipoPesquisaContratosChange(target.value);
        if (target.value === 'todos' || target.value === 'ativos') {
            setPesquisa('');
        }
    }

    return (
        <Alert style={{background: 'ghostwhite', color: 'dimGray'}}>
            <Row>
              <Col md='3'>
                 <Alert.Heading style={{textAlign: 'left', fontSize: '1.5rem'}}>{titulo}</Alert.Heading>
              </Col>    

              <Col md='2'>
                <Form.Select  onChange={({target}) => atualizarTipoPesquisa({target})} value={tipoPesquisaContratos || '0'} className=" form-select-control" >
                        <option disabled value="0">Opções</option>
                        <option value="ns">Número Série</option>
                        <option value="distribuidor">Revenda</option>
                        <option value="cliente">Cliente</option>
                        <option value="sistema">Sistema</option>
                        <option value="ativos">Ativos</option>
                        <option value="todos">Mostrar Todos</option>
                </Form.Select>      
              </Col>

              <Col md='3'>
                <InputGroup className="mb-3">
                    <Form.Control placeholder={(tipoPesquisaContratos === 'todos') ? 'Pesquisa desabilitada' : 'Pesquisa Parcial:'} value={pesquisa}
                                  style={{fontSize: '0.8rem'}} disabled={tipoPesquisaContratos === 'todos' || tipoPesquisaContratos === 'ativos'}
                                  onKeyDown={(e) => { if (e.key === 'Enter') pesquisarClick(e); }}
                                  onChange={({ target }) => setPesquisa(target.value)}/>

                        <Button onClick={pesquisarClick} variant="outline-primary">
                            <Search size={15} />
                        </Button>
                </InputGroup>
              </Col>    

              <Col md='1'>
              </Col>     
             </Row>             
        </Alert>
    )
}

export default HeaderContratos;